import script from "./ViewAddMatchRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAddMatchRecord.vue?vue&type=script&setup=true&lang=js"

import "./ViewAddMatchRecord.vue?vue&type=style&index=0&id=6170dce6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6170dce6"]])

export default __exports__